import React, { useEffect } from "react"
import Glide from "@glidejs/glide"
import '@glidejs/glide/dist/css/glide.core.min.css';
import '@glidejs/glide/dist/css/glide.theme.min.css';

class CarouselLogo extends React.Component {
    componentDidMount() {
        new Glide('.glide', {
          type: 'carousel',
          perView: 5,
          gap: 20,
          autoplay: 3000, // Adjust autoplay interval as needed
          animationDuration: 1000, // Adjust animation duration as needed
          hoverpause: false, // Disable pausing on hover
          rewind: true, // Enable continuous loop
        }).mount();
      }

    render() {
      return (
        <div className="glide relative top-3 lg:static lg:top-0">
          <div className="glide__track" data-glide-el="track">
            <ul className="glide__slides ">
              {/* Render your logo items here */}
              <li className="glide__slide my-auto  "><img src="./images/1.png" alt="Logo 1" /></li>
              <li className="glide__slide my-auto"><img src="./images/2.jpg" alt="Logo 2" /></li>
              <li className="glide__slide my-auto"><img src="./images/6.png" alt="Logo 6" /></li>
              <li className="glide__slide my-auto"><img src="./images/9.png" alt="Logo 9" /></li>
              <li className="glide__slide my-auto"><img src="./images/10.png" alt="Logo 10" /></li>
              <li className="glide__slide my-auto"><img src="./images/11.png" alt="Logo 11" /></li>
              <li className="glide__slide my-auto"><img src="./images/13.webp" alt="Logo 13" /></li>
              <li className="glide__slide my-auto"><img src="./images/14.png" alt="Logo 14" /></li>
              <li className="glide__slide my-auto"><img src="./images/15.jpg" alt="Logo 15" /></li>
              <li className="glide__slide my-auto"><img src="./images/16.png" alt="Logo 16" /></li>
              <li className="glide__slide my-auto"><img src="./images/17.png" alt="Logo 17" /></li>
              <li className="glide__slide my-auto"><img src="./images/18.png" alt="Logo 18" /></li>
              <li className="glide__slide my-auto"><img src="./images/19.png" alt="Logo 19" /></li>
              <li className="glide__slide my-auto"><img src="./images/20.png" alt="Logo 20" /></li>
              <li className="glide__slide my-auto"><img src="./images/21.png" alt="Logo 21" /></li>
              <li className="glide__slide my-auto"><img src="./images/22.png" alt="Logo 22" /></li>
              {/* Add more logo items as needed */}
            </ul>
          </div>
        </div>
      );
    }
  }
  
  export default CarouselLogo;
  